//# sourceMappingURL=my-marked-dates.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-marked-dates.interface.js
// module id = 866
// module chunks = 9